import { ParsedUrlQuery } from 'querystring';

export const isPdpPage = (url: string, query: ParsedUrlQuery = {}) => query?.productTemplateSlug;
